import React from 'react'
import { Link } from 'react-router-dom'
import Pouces from '../images/sara_pouces.png'

export default function CheckMailbox() {
	return (
		<div className="h-screen text-general-blue flex items-center">

			<div className="mx-auto text-center text-gray-600 font-bold text-2xl space-y-4">
				<img src={Pouces} className="h-80 mx-auto" />
				<div className="space-y-1">
					<h1>Merci pour votre inscription !</h1>
					<h2 className='text-lg text-gray-500 font-semibold'>Vérifiez votre boite de réception</h2>
					<p className="text-sm font-medium text-gray-500">Pour commencer à utiliser notre plateforme Azatys, nous vous avons envoyé un lien de vérification. </p>
					<p className="text-sm font-medium text-gray-500">Veuillez confirmer votre identité</p>
					<p><span className="text-xs italic">Pensez à regarder dans vos courriers indésirables</span></p>
				</div>
				<Link to="/login" className="w-full uppercase space-x-2 flex justify-center py-3 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 disabled:bg-gray-500 disabled:text-gray-300 disabled:cursor-not-allowed transition-colors">
					Je me connecte
				</Link>
			</div>
		</div>
	)
}